import React, { useState, useContext, useEffect, useRef } from 'react';
import Utility from './../../Utility';
import Page from './../../components/Page/Page';
import Box from './../../components/Box/Box';
import { Image, Grid, List, Segment, Input, Dropdown, Item, Button } from 'semantic-ui-react';
import Gmap from '../../components/Maps/Gmap';
import GmapMulti from '../../components/Maps/GmapMultiMarker';
import GlobalContext from './../../contexts/GlobalContext';
import InputSelect from "../../components/FormInputCustomer/InputSelect/InputSelect";
import EstablishmentLoader from './EstablishmentLoader';
import EstablishmentCard from '../../components/Widgets/Establishment/Establishment';
import EstablishmentCardV2 from '../../components/Widgets/Establishment/EstablishmentV2';
import useResponsive from "../../hooks/useResponsive";
import './establishment.css';

const Establishment = props => {

  const [globalContext] = useContext(GlobalContext);
  const [isLoadingState, setIsLoadingState] = useState(true);
  const [showMultiEtabState, setShowMultiEtabState] = useState(false);  
  const [listWidgetsState, setListWidgetsState] = useState([]);
  const [refreshListState, setRefreshListState] = useState(false);
  const [filterFromState, setFilterFromState] = useState('');
  
  const { isMobile, isTablet } = useResponsive();
  
  var fullEstablishmentArray = Object.values( globalContext.establishmentCollection )

  fullEstablishmentArray.sort((a, b) => {
    if (a.name > b.name) { return 1; }
    if (a.name < b.name) { return -1; }
    return 0;
  })
  //fullEstablishmentArray.push( globalContext.establishment )

  const [filtredEstablishments, setFiltredEstablishments] = useState(fullEstablishmentArray)
  //const [filtredEstablishments2, setFiltredEstablishments2] = useState(Object.values(props.globalEstablishmentCollection))

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoadingState(false);
      if ( globalContext.espaceClientByOrga && Object.keys(globalContext.establishmentCollection).length > 0 ) {
        setShowMultiEtabState(true);
      }
    }, 700)

    return () => {
      clearTimeout(timeout);
    }
  }, [])

  useEffect(() => {
    //console.log('useEffect listWidgets')
    let listWidgets = [];
    if ( filtredEstablishments.length > 0 ){
      for (let etabTemp of filtredEstablishments) {
        if ( etabTemp?.testEstablishment != "oui"  || etabTemp?.organizationId == 2113 ) {
          listWidgets.push(getCardEtab(etabTemp))
        }
      }
    }
    setFilterFromState('map')
    setListWidgetsState( listWidgets );
    

  }, [globalContext.establishmentCollection, refreshListState])
  //setListWidgetsState( listWidgets );

  const getDataSelectCity = () => {
    //console.log('getDataSelectCity')

    let tabCity = [];
    let dataSelectCity = [];
    if ( filtredEstablishments.length > 0 ){
      for (let etabTemp of filtredEstablishments) {

        let citySlug = Utility.slugify(etabTemp?.city);

        if( typeof tabCity[citySlug] == 'undefined' && (etabTemp?.testEstablishment != "oui" || etabTemp?.organizationId == 2113) ){
          tabCity[citySlug] = citySlug;
          dataSelectCity.push( {key: citySlug, text: etabTemp?.city, value: citySlug } )
        }
      }
    }

    dataSelectCity.sort((a, b) => {
      if (a.text > b.text) {
        return 1;
      }
      if (a.text < b.text) {
        return -1;
      }
      return 0;
    })

    dataSelectCity.unshift( {key: 'allCity', text: globalContext.translations.allTheCity, value: 'allCity' } )

    return dataSelectCity;
  }

  const getCardEtab = ( etabTemp ) => {

    let displayCard = 'flex';
    if (etabTemp?.display == false ) {
      displayCard = 'none'
    }
    else{
      etabTemp.display = true
    }

    /*let dataReturn = (
        <Grid.Column key={etabTemp?.id} className="mb-5" computer={4} tablet={8} mobile={16} style={{display: displayCard}}>
          <EstablishmentCard setActiveItemMenu={""} etab={ etabTemp } />
        </Grid.Column>
    );*/
    let dataReturn = (
      <Item key={etabTemp?.id} style={{display: displayCard}} onClick={(e) => selecItemMap(e, etabTemp?.id)}>
        <EstablishmentCardV2 key={etabTemp?.id} setActiveItemMenu={""} etab={ etabTemp }  style={{display: displayCard}} />
      </Item>
    );
    return dataReturn;
  }

  const handleSearchEstablishment = (e) => {

    const value = e.target.value
    const filter = new RegExp( value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim(), 'i' )

    const findedEstablishment = fullEstablishmentArray.map( etab => {
      
      if (etab?.testEstablishment != "oui" || etab?.organizationId == 2113) {
        const name = etab.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").match(filter)
        const zipCode = etab.zipCode.normalize("NFD").replace(/[\u0300-\u036f]/g, "").match(filter)
        const city = etab.city.normalize("NFD").replace(/[\u0300-\u036f]/g, "").match(filter)

        if (name || zipCode || city) {
          etab.display = true
        } else {
          etab.display = false
        }
      }
      else{
        etab.display = false
      }
      
      return etab
    } );

    setFilterFromState('user')
    setFiltredEstablishments( findedEstablishment );
    let toggle = true
    if (refreshListState) {
      toggle = false
    }
    setRefreshListState(toggle)
  }

  const handleSelectEstablishment = (name, selected) => {

    const findedEstablishment = fullEstablishmentArray.map( etab => {

      if (etab?.testEstablishment != "oui" || etab?.organizationId == 2113) {
        let citySlug = Utility.slugify(etab?.city);
        if( selected.value == 'allCity' ){
          etab.display = true;
        }
        else if(citySlug == selected.value){
          etab.display = true;
        }
        else{
          etab.display = false;
        }
      }
      else{
        etab.display = false;
      }

      return etab
    });

    setFilterFromState('user')
    setFiltredEstablishments( findedEstablishment );
    let toggle = true
    if (refreshListState) {
      toggle = false
    }
    setRefreshListState(toggle)
  }

  const selecItemMap = (e, id ) => {

    // si pas le lien vers le BE
    if( !e.target.classList.contains("showBe") && !e.target.hasAttribute("href") ){
      const findedEstablishment = fullEstablishmentArray.map( etab => {
        //let citySlug = Utility.slugify(etab?.city);
        if (etab?.testEstablishment != "oui" || etab?.organizationId == 2113){
          if( id == 'allCity' ){
            etab.display = true;
          }
          else if(etab.id == id){
            etab.display = true;
          }
          else{
            etab.display = false;
          }
        }
        else{
          etab.display = false;
        }
        return etab
      });
  
      setFilterFromState('user')
      setFiltredEstablishments( findedEstablishment );
      let toggle = true
      if (refreshListState) {
        toggle = false
      }
      setRefreshListState(toggle)
    }
    
  }

  /**
   * 
   * @param {*} filtredEstab 
   */
  const refreshMap = ( filtredEstab ) => {

    setFilterFromState('map')
    setFiltredEstablishments( filtredEstab )
    let toggle = true
    if (refreshListState) {
      toggle = false
    }
    setRefreshListState(toggle)
  }

  
  const getListCardEtab = () => {
    
    const body = (
      <div>
        <Grid className="mb-5 mt-2" style={{ height: '100%' }} >
          
          <Grid.Row centered >
            <Grid.Column className="mb-2" mobile={2} tablet={2} computer={1}>
              <div className="mr-1">
                <button className="ui icon button" onClick={(e) => selecItemMap(e, 'allCity')}>
                  <i aria-hidden="true" className="reply icon"></i>
                </button>
              </div>
            </Grid.Column>
          
            <Grid.Column className="mb-2" mobile={14} tablet={14} computer={7}>
              <Dropdown
                selection
                placeholder='choisir votre ville'
                options={ getDataSelectCity() }
                fluid 
                search={true}
                onChange={handleSelectEstablishment}
              >
              </Dropdown>
            </Grid.Column>
            <Grid.Column className="mb-2" mobile={16} tablet={16} computer={8}>
              <Input 
                type="text" 
                icon='search'
                placeholder='Search...'
                onChange={handleSearchEstablishment} 
                fluid 
              />
            </Grid.Column>
          </Grid.Row>
          
          <Grid.Row>
            <Grid.Column className="mb-5" mobile={16} tablet={16} computer={8}>
              <Grid.Row>
                <Item.Group divided unstackable className="boxMultiEtab">
                  {listWidgetsState}
                </Item.Group>
              </Grid.Row>
            </Grid.Column>
            
            <Grid.Column className="mb-2" mobile={16} tablet={16} computer={8}>
              <Button
                id="showAllEtab"
                color='teal'
                size='mini'
                content={globalContext.translations.showAllTheCity}
                icon="undo"
                labelPosition="left"
                onClick={(e) => selecItemMap(e, 'allCity')}
              />
         
              <GmapMulti filtredEstablishments={filtredEstablishments} refreshMap={refreshMap} filterFrom={filterFromState} />
            </Grid.Column>
            
          </Grid.Row>
        </Grid>
      </div>
    );

    return body;

  }
  
  /**
   * 
   * @returns 
   */
  const getContent = () => {

    var pageHtml;
    if ( showMultiEtabState ) {
      pageHtml = (
        <div>
          {getListCardEtab()}
        </div>
      );
    }
    else{
      pageHtml = (
        <Segment>
          <Grid style={{ height: "auto" }} verticalAlign="middle" columns={2}>

            <Grid.Row only="computer" style={{ height: "100%" }}>
              <Grid.Column mobile={16} computer={8}>
                <Image src={Utility.imageExists(globalContext.establishment.logo, 'logo')} size="medium" />
              </Grid.Column>
              <Grid.Column mobile={16} computer={8} verticalAlign="middle" className="pl-4 pr-5 pb-3 pt-3">
                <div style={{ textAlign: "center" }}>
                  <h2 style={{ textAlign: "center" }}>{globalContext.establishment.lastName}</h2>
                  <List size="massive">
                    <List.Item>
                      <List.Icon name="map signs" className="mbBlue" verticalAlign="middle" />
                      <List.Content>
                        {globalContext.establishment.firstAddress}
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="globe" className="mbBlue" verticalAlign="middle" />
                      <List.Content>{globalContext.establishment.zipCode}, {globalContext.establishment.city}</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="mail" className="mbBlue" verticalAlign="middle" />
                      <List.Content>
                        <a href={`mailto:${globalContext.establishment.mail}`}>{globalContext.establishment.mail}</a>
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="phone" className="mbBlue" verticalAlign="middle" />
                      <List.Content>
                        <a href={`tel:${globalContext.establishment.telephone}`}>{globalContext.establishment.telephone}</a>
                      </List.Content>
                    </List.Item>
                  </List>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row only="mobile tablet">
              <Grid.Column mobile={16} computer={8}>
                <Grid.Column mobile={16} computer={10}>
                  <Image src={Utility.imageExists(globalContext.establishment.logo, 'logo')} size="medium" />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column mobile={16} computer={8} verticalAlign="middle">
                <div>
                  <h4 style={{ textAlign: "center" }}>{globalContext.establishment.lastName}</h4>
                  <List style={{ textAlign: "left" }} size="massive">
                    <List.Item>
                      <List.Icon name="map signs" className="mbBlue" verticalAlign="middle" />
                      <List.Content>
                        {globalContext.establishment.firstAddress}
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="marker" className="mbBlue" verticalAlign="middle" />
                      <List.Content>{globalContext.establishment.zipCode}, {globalContext.establishment.city}</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="mail" className="mbBlue" verticalAlign="middle" />
                      <List.Content>
                        <a href={`mailto:${globalContext.establishment.mail}`}>{globalContext.establishment.mail}</a>
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Icon name="phone" className="mbBlue" verticalAlign="middle" />
                      <List.Content>
                        <a href="tel:{globalContext.establishment.telephone}">{globalContext.establishment.telephone}</a>
                      </List.Content>
                    </List.Item>
                  </List>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className="mt-5">
          <Gmap lat={parseFloat(globalContext.establishment.latitude)} lng={parseFloat(globalContext.establishment.longitude)} zoom={13} establishment={globalContext.establishment}/>
          {/* <Gmap lat={globalContext.establishment.latitude} lng={globalContext.establishment.longitude} zoom={13} /> */}
          {/* <BoxMap latitude={globalContext.establishment.latitude} longitude={globalContext.establishment.longitude} /> */}
        </div>
        </Segment>
      );
    }

    return pageHtml;

    
  }
  
  return (
    <div>
      { isLoadingState 
        ? <EstablishmentLoader />
        : <div>
            <Page location={props.location} history={props.history}>
              <Box message={false} header={Utility.getHeaderPage('establishment', globalContext.translations)}>
              </Box>
            </Page>
            {getContent()}
          </div>
      }
    </div>
  )
}

/*const mapProps = state => ({
  globalEstablishmentCollection: state.establishmentCollection.establishmentCollection,
})

const mapDispatch = dispatch => ({
  setEstablishmentCollection: dispatch.establishmentCollection.load,
})*/

//export default connect(mapProps, mapDispatch)(Establishment);

export default Establishment;